document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.card__variant-form').forEach(form => {
    const handle = form.dataset.productHandle;
    const selects = form.querySelectorAll('.card__variant-select');
    const variantIdInput = form.querySelector('.card__variant-id');
    const submitButton = form.querySelector('.card__quick-add-submit');

    // Fetch variant data for this product
    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {
        const variants = product.variants;

        function getSelectedVariant() {
          const selectedOptions = Array.from(selects).map(s => s.value);
          return variants.find(v =>
            v.options.every((opt, i) => opt === selectedOptions[i])
          );
        }

        function updateForm(variant) {
  if (!variant) {
    variantIdInput.value = '';
    submitButton.disabled = true;
    submitButton.querySelector('span').textContent = 'Add to cart';
    return;
  }
  variantIdInput.value = variant.id;
  if (variant.available) {
    submitButton.disabled = false;
    submitButton.querySelector('span').textContent = 'Add to cart';
  } else {
    submitButton.disabled = true;
    submitButton.querySelector('span').textContent = 'Sold out';
  }
}

        // Set initial state — disabled until user picks a variant
variantIdInput.value = '';
submitButton.disabled = true;
updateForm(null);

        // Update on change
        selects.forEach(select => {
          select.addEventListener('change', () => {
            updateForm(getSelectedVariant());
          });
        });
      });
  });
});